import { render, staticRenderFns } from "./payslipData.vue?vue&type=template&id=c06eef34&"
import script from "./payslipData.vue?vue&type=script&lang=js&"
export * from "./payslipData.vue?vue&type=script&lang=js&"
import style0 from "./payslipData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports